import {UserDetailsRes} from '../cp';

export class SetPasswordReq {
    newPassword: string = "";
    requirePasswordChange: boolean = false;
}

export class GenerateTemporaryPasswordReq {
    sendMail: boolean = true;
}

export enum RmEmploymentType {
    Permanent = 1,
    Temporary = 2,
    WorkingStudent = 3,
    Intern = 4,
    Freelancer = 5,
    MiniJob = 6,
    Ausbildung = 7
}

export enum CompensationType {
    MonthlySalary = 1,
    HourlyRate = 2
}

export class AdminUserContractVersionOnboardReq {
    validFrom: any = new Date();
    validTo?: any;
    employmentType: RmEmploymentType = RmEmploymentType.Permanent;
    isTemporary: boolean = false;
    temporaryUntil?: any;
    probePeriodUntil?: any;
    weeklyHours: number = 40;
    weeklyWorkingDays: number = 5;
    vacationDaysPerYear: number = 30;
    compensationType: CompensationType = CompensationType.MonthlySalary;
    monthlySalary: number = 0;
    hourlyRate: number = 0;
    currency: string = 'EUR';
    contractDocumentId?: string;
    note?: string;
}


export class AdminUserContractVersionUpdateReq extends AdminUserContractVersionOnboardReq {
    id!: string;
}

export class RmEmploymentContractVersionDetailRes {
    id!: string;
    employmentId!: string;
    versionNo!: number;
    validFrom!: any;
    validTo?: any;
    employmentType!: RmEmploymentType;
    isTemporary!: boolean;
    temporaryUntil?: any;
    probePeriodUntil?: any;
    weeklyHours!: number;
    weeklyWorkingDays!: number;
    vacationDaysPerYear!: number;
    compensationType!: CompensationType;
    monthlySalary?: number;
    hourlyRate?: number;
    currency!: string;
    contractDocumentId?: string;
    note?: string;
    isCurrent!: boolean;
    created!: any;
}

export class RmEmploymentDetailRes {
    id!: string;
    userId!: number;
    employmentStart!: any;
    noticeDate?: any;
    exitDatePlanned?: any;
    exitDateActual?: any;
    isActive!: boolean;
    created!: any;
    currentContractVersion?: RmEmploymentContractVersionDetailRes;
    contractVersions: RmEmploymentContractVersionDetailRes[] = [];
}

export class AdminUserEmploymentOnboardReq {
    userId: number = 0;
    employmentStart: any = new Date();
    noticeDate?: any;
    exitDatePlanned?: any;
    exitDateActual?: any;
    isActive: boolean = true;
    contractVersion: AdminUserContractVersionOnboardReq = new AdminUserContractVersionOnboardReq();
}

export class AdminUserEmploymentSaveReq {
    employmentStart?: any;
    noticeDate?: any;
    exitDatePlanned?: any;
    exitDateActual?: any;
    isActive?: boolean;
    currentContractVersion?: AdminUserContractVersionUpdateReq;
    contractVersion?: AdminUserContractVersionOnboardReq;
}

export class AdminUserOnboardReq {
    title?: string;
    salutation!: number;
    givenName!: string;
    lastName!: string;
    birthDate?: any;
    departmentId?: string;
    email!: string;
    phoneNumber?: string;
    language?: string;
    password?: string;
    isManagingDirector: boolean = false;
    roleIds: number[] = [];
    employment?: AdminUserEmploymentOnboardReq;
}

export class AdminUserOnboardRes {
    user!: UserDetailsRes;
    employment?: RmEmploymentDetailRes;
}
